import Cookies from 'cookie-universal'
import type { Product } from '@mc/api'
import { META_LAST_PRODUCT_ID_COOKIE } from '@mc/constants'
import { getLTVPriceValueFromProduct } from '@mc/products'

/**
 * Builds the Meta-pixel-style `product_id` + `contents` properties shared by the
 * purchase-funnel events.
 *
 * The id resolves to the Meta catalog cookie (`meta_last_product_id`, the last
 * Meta-attributed product id) when present, otherwise the passed product's id
 * (e.g. the annual-pass / default tier product).
 *
 * `contents[].price` is the product's pre-purchase LTV (`productLtv.regular`,
 * or `productLtv.gift` when `isGift`) — the same value the rest of the funnel
 * reports as price/revenue (e.g. "Product Added"). It matches the "Order
 * Complete" `revenue` in the default LTV path. Omitted when the product has no
 * LTV. Note the price tracks the passed `product`, which may differ from `id`
 * when the Meta catalog cookie is present.
 */
export const getMetaCatalogProductProps = (
  product?: Product | null,
  isGift = false,
) => {
  const cookies = Cookies()
  const metaProductId = cookies.get(META_LAST_PRODUCT_ID_COOKIE) as
    | string
    | undefined

  const id = metaProductId || product?.id

  const price = product
    ? getLTVPriceValueFromProduct(isGift, product)
    : undefined

  return {
    product_id: id,
    contents: [
      {
        quantity: 1,
        id,
        ...(price != null && { price }),
      },
    ],
  }
}
